<mat-radio-button [value]="buttonValue()" class="radio-button-with-description">
  <div class="radio-content-wrapper">
    <span data-id="radioBtnLabel" class="radio-label">{{ label() }}</span>
    <span class="radio-description">{{ description() }}</span>
  </div>
</mat-radio-button>
